export default __webpack_public_path__ + "static/archived-697892382c4d0ca70b6bebf008536527.svg";